import $ from "../components/ajax";
const token =localStorage.getItem("token");
console.log("API",token)
//登录
export const userLogin=data=>{
    return $.ajax({
        url:"user/login",
        type:'post',
        data:data,
        tip:true,
    });
}

export const ssoLogin=data=>{
    return $.ajax({
        url:"user/sso-login",
        type:'post',
        data:data,
        tip:true,
    });
}
export const editPwd=data=>{
    return $.ajax({
        url:"user/edit-pwd",
        type:'post',
        token:true,
        data:data,
        tip:true,
    });
}
export const isSimplePwd=data=>{
    return $.ajax({
        url:"token/login-simple-pwd",
        token:true,
        type:'post',
        api:'login-api',
        data:data
    });
}
export const smsCode=data=>{
    return $.ajax({
        url:"sms/code",
        type:'post',
        data:data,
        tip:true,
    });
}
export const logOut=data=>{
    return $.ajax({
        url:"user/logout",
        type: 'post',    
        data:data,
        token,
    });
}
export const getCodeImg=data=>{
    return $.ajax({
        url:"user/captchaImage",
        type:'get',
        data:data,
    });
}
export const getUserInfo=data=>{
    return $.ajax({
        url:"user/getCurrentUser",
        type:'get',
        data:data,
        token,
    });
}






